import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';

import styles from './AnyEvent.module.postcss';
import ConfigContext from '../../../contexts/ConfigContext';

const defaultEvents = [
  {
    title: 'Corporate Catering',
    link: '/food-truck-catering/corporate-catering',
    text: 'Catered Food Truck Lunch Programs, In-Office Meal Programs, Business Park Lunches, Employee Appreciation, Client Appreciation, Holiday Parties, Milestone Celebrations, Retail Events',
    icon: 'https://static.seattlefoodtruck.com/badges/bubbles.svg'
  },
  {
    title: 'Private Parties',
    link: '/food-truck-catering/private-parties',
    text: 'Birthday Parties, Anniversary Celebrations, Graduation Parties, Family Reunions, Neighborhood Gatherings, Holiday Parties, Backyard BBQs, Pool Parties',
    icon: 'https://static.seattlefoodtruck.com/badges/mask.svg'
  },
  {
    title: 'Wedding Catering',
    link: '/food-truck-catering/wedding-catering',
    text: 'Wedding Receptions, Rehearsal Dinners, Bridal Showers, Bachelor/Bachelorette Parties, Wedding Welcome Events, Post-Wedding Brunches, Engagement Parties',
    icon: 'https://static.seattlefoodtruck.com/badges/weddingrings.svg'
  },
  {
    title: 'Community Events',
    link: '/food-truck-catering/community-events',
    text: 'Festivals, Farmers Markets, School Events, Fundraisers, Church Events, Sporting Events, Concert Venues, Art Shows, Street Fairs',
    icon: 'https://static.seattlefoodtruck.com/badges/stage.svg'
  },
  {
    title: 'Special Occasions',
    link: '/food-truck-catering/special-occasions',
    text: 'Grand Openings, Product Launches, Real Estate Open Houses, Charity Events, Political Events, Trade Shows, Conferences, Team Building Events',
    icon: 'https://static.seattlefoodtruck.com/badges/cake.svg'
  },
  {
    title: 'Regular Services',
    link: '/food-truck-catering/office-lunch',
    text: 'Office Building Lunch Service, Construction Site Catering, Hospital Staff Meals, University Campus Events, Apartment Complex Events, Weekly Route Service',
    icon: 'https://static.seattlefoodtruck.com/badges/party.svg'
  }
];

function Event({ title, text, icon, iconWidth, link }) {
  return (
    <div className='u-flex'>
      <div className={styles.DarkSection_Icon}>
        <img
          src={icon}
          alt={title}
          loading='lazy'
          fetchpriority='low'
          className={cn({
            [styles.iconSm]: iconWidth === 'sm',
            [styles.iconLg]: iconWidth === 'lg'
          })}
        />
      </div>
      <div>
        <h3 className='u-strong'>
          {link ? <Link to={link}>{title}</Link> : title}
        </h3>
        <p>{text}</p>
      </div>
    </div>
  );
}

function AnyEvent({ title, events }) {
  const { vehicle_type } = useContext(ConfigContext);

  const eventsToRender = events || defaultEvents;

  return (
    <section className={cn('Section', styles.DarkSection)}>
      <h2 className='u-textCenter'>{ title || `Food ${vehicle_type} Catering For Any Event` }</h2>
      <div className={styles.DarkSection_Grid}>
        { eventsToRender.map((event) => (
          <Event
            key={event.title}
            title={event.title}
            text={event.text}
            icon={event.icon}
            iconWidth={event.width}
            link={event.link}
          />
        )) }
      </div>
    </section>
  );
}

export default AnyEvent;
